import { render, staticRenderFns } from "./ItemLesson.vue?vue&type=template&id=55a49dc6&scoped=true&"
import script from "./ItemLesson.vue?vue&type=script&lang=js&"
export * from "./ItemLesson.vue?vue&type=script&lang=js&"
import style0 from "./ItemLesson.vue?vue&type=style&index=0&id=55a49dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a49dc6",
  null
  
)

export default component.exports